import {
  FETCH_BOOKINGS,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILED,
  UPDATE_BOOKING,
  CANCEL_BOOKING
} from "../store/types";
import { fetchBookingLocations } from '../actions/locationactions';
import { RequestPushMsg } from '../other/NotificationFunctions';
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { get, onValue, update, off, remove, push } from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";

export const fetchBookings = () => (dispatch) => {

  const {
    bookingListRef,
  } = firebase;

  dispatch({
    type: FETCH_BOOKINGS,
    payload: null,
  });

  const userInfo = store.getState().auth.profile;

  off(bookingListRef(userInfo.uid, userInfo.usertype));
  onValue(bookingListRef(userInfo.uid, userInfo.usertype), (snapshot) => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const active = [];
      let tracked = null;
      const bookings = Object.keys(data)
        .filter(key => userInfo.usertype !== 'fleetadmin' || (userInfo.usertype === 'fleetadmin' && (data[key].fleetadmin === userInfo.uid || data[key].fleetadminrider === userInfo.uid)))
        .map((i) => {
          data[i].id = i;
          data[i].pickupAddress = data[i].pickup.add;
          data[i].dropAddress = data[i].drop.add;
          data[i].discount = data[i].discount
            ? data[i].discount
            : 0;
          data[i].cashPaymentAmount = data[i].cashPaymentAmount
            ? data[i].cashPaymentAmount
            : 0;
          data[i].cardPaymentAmount = data[i].cardPaymentAmount
            ? data[i].cardPaymentAmount
            : 0;
          return data[i];
        });
      for (let i = 0; i < bookings.length; i++) {
        if (['PAYMENT_PENDING', 'NEW', 'ACCEPTED', 'ARRIVED', 'STARTED', 'REACHED', 'PENDING', 'PAID'].indexOf(bookings[i].status) != -1) {
          active.push(bookings[i]);
        }
        if ((['ACCEPTED', 'ARRIVED', 'STARTED'].indexOf(bookings[i].status) != -1) && userInfo.usertype == 'driver') {
          tracked = bookings[i];
          fetchBookingLocations(tracked.id)(dispatch);
        }
      }
      dispatch({
        type: FETCH_BOOKINGS_SUCCESS,
        payload: {
          bookings: bookings.reverse(),
          active: active,
          tracked: tracked
        },
      });
      if (tracked) {
        dispatch({
          type: FETCH_BOOKINGS_SUCCESS,
          payload: null
        });
      }
    } else {
      dispatch({
        type: FETCH_BOOKINGS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_bookings,
      });
    }
  });
};


export const updateBooking = (booking) => async (dispatch) => {

  const {
    auth,
    trackingRef,
    singleBookingRef,
    singleUserRef,
    settingsRef,
    userRatingsRef,
    userLocationRef
  } = firebase;

  dispatch({
    type: UPDATE_BOOKING,
    payload: booking,
  });

  if (booking.shareToken && firebase.sharedTripsRef) {
    const isFinished = ['COMPLETE', 'CANCELLED'].includes(booking.status);
    update(firebase.sharedTripsRef(booking.shareToken), {
      status: booking.status,
      active: !isFinished,
      updatedAt: Date.now()
    }).catch((err) => console.log('Error updating shared trip:', err));
  }

  if (booking.status == 'PAYMENT_PENDING') {
    update(singleBookingRef(booking.id), booking);
  }

  if (booking.status == 'NEW' || booking.status == 'ACCEPTED') {
    if (booking.hasBid) {
      if (booking.driver && booking.prepaid) {
        booking.status = 'ACCEPTED';
      }
      update(singleUserRef(booking.driver), { queue: false });
    }
    update(singleBookingRef(booking.id), booking);
  }
  if (booking.status == 'ACCEPTED' && booking.driver && booking.hasBid) {
    const driverLocData = await get(userLocationRef(booking.driver));
    const driverLocation = driverLocData.val();
    push(trackingRef(booking.id), {
      at: new Date().getTime(),
      status: 'ACCEPTED',
      lat: driverLocation.lat,
      lng: driverLocation.lng,
    });
  }

  if (booking.status == 'ARRIVED') {
    let dt = new Date();
    booking.driver_arrive_time = dt.getTime().toString();
    update(singleBookingRef(booking.id), booking);
    if (booking.customer_token) {
      RequestPushMsg(
        booking.customer_token,
        {
          title: store.getState().languagedata.defaultLanguage.notification_title,
          msg: store.getState().languagedata.defaultLanguage.driver_near,
          screen: 'BookedCab',
          params: { bookingId: booking.id }
        }
      );
    }
  }
  if (booking.status == 'STARTED') {
    let dt = new Date();
    let localString = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
    let timeString = dt.getTime();
    booking.trip_start_time = localString;
    booking.startTime = timeString;
    update(singleBookingRef(booking.id), booking);

    const driverLocation = store.getState().gpsdata.location;

    push(trackingRef(booking.id), {
      at: new Date().getTime(),
      status: 'STARTED',
      lat: driverLocation.lat,
      lng: driverLocation.lng
    });
    if (booking.customer_token) {
      RequestPushMsg(
        booking.customer_token,
        {
          title: store.getState().languagedata.defaultLanguage.notification_title,
          msg: store.getState().languagedata.defaultLanguage.driver_journey_msg + booking.reference,
          screen: 'BookedCab',
          params: { bookingId: booking.id }
        }
      );
    }
  }
  if (booking.status == 'REACHED') {

    const driverLocation = store.getState().gpsdata.location;

    push(trackingRef(booking.id), {
      at: new Date().getTime(),
      status: 'REACHED',
      lat: driverLocation.lat,
      lng: driverLocation.lng
    });

    const end_time = new Date();
    const diff = (end_time.getTime() - parseFloat(booking.startTime)) / 1000;
    const totalTimeTaken = Math.abs(Math.round(diff));
    booking.trip_end_time = end_time.getHours() + ":" + end_time.getMinutes() + ":" + end_time.getSeconds();
    booking.endTime = end_time.getTime();
    booking.total_trip_time = totalTimeTaken;

    update(singleBookingRef(booking.id), booking);
    if (booking.customer_token) {
      RequestPushMsg(
        booking.customer_token,
        {
          title: store.getState().languagedata.defaultLanguage.notification_title,
          msg: store.getState().languagedata.defaultLanguage.driver_completed_ride,
          screen: 'BookedCab',
          params: { bookingId: booking.id }
        }
      );
    }
  }
  if (booking.status == 'PENDING') {
    update(singleBookingRef(booking.id), booking);
    update(singleUserRef(booking.driver), { queue: false });
  }
  if (booking.status == 'PAID') {
    if (booking.booking_from_web) {
      booking.status = 'COMPLETE';
    }
    update(singleBookingRef(booking.id), booking);
    if (booking.driver == auth.currentUser.uid && (booking.prepaid || booking.payment_mode == 'cash' || booking.payment_mode == 'wallet')) {
      update(singleUserRef(booking.driver), { queue: false });
    }

    if (booking.customer_token) {
      RequestPushMsg(
        booking.customer_token,
        {
          title: store.getState().languagedata.defaultLanguage.notification_title,
          msg: store.getState().languagedata.defaultLanguage.success_payment,
          screen: 'BookedCab',
          params: { bookingId: booking.id }
        }
      );
    }

    if (booking.driver_token) {
      RequestPushMsg(
        booking.driver_token,
        {
          title: store.getState().languagedata.defaultLanguage.notification_title,
          msg: store.getState().languagedata.defaultLanguage.success_payment,
          screen: 'BookedCab',
          params: { bookingId: booking.id }
        }
      );
    }
  }
  if (booking.status == 'COMPLETE' || booking.customer_rating) {
    update(singleBookingRef(booking.id), booking);
    if (booking.rating) {
      if (booking.driver_token) {
        RequestPushMsg(
          booking.driver_token,
          {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.received_rating.toString().replace("X", booking.rating.toString()),
            screen: 'RideList',
            params: { tabIndex: 1 }
          }
        );
      }

      onValue(userRatingsRef(booking.driver), snapshot => {
        let ratings = snapshot.val();
        let rating;
        if (ratings) {
          let sum = 0;
          const arr = Object.values(ratings);
          for (let i = 0; i < arr.length; i++) {
            sum = sum + arr[i].rate
          }
          sum = sum + booking.rating;
          rating = parseFloat(sum / (arr.length + 1)).toFixed(1);
        } else {
          rating = booking.rating;
        }
        update(singleUserRef(booking.driver), { rating: rating });
        const customerId = booking.customer || booking.customer_id;
        if (booking.rating <= 2) {
          if (customerId && booking.driver) {
            update(singleUserRef(booking.driver), { [`blockedCustomers/${customerId}`]: true });
          } else if (booking.id && booking.driver) {
            get(singleBookingRef(booking.id)).then((snap) => {
              if (snap.exists() && snap.val().customer) {
                update(singleUserRef(booking.driver), { [`blockedCustomers/${snap.val().customer}`]: true });
              }
            });
          }
        }
        push(userRatingsRef(booking.driver), {
          user: customerId || null,
          rate: booking.rating
        });
      }, { onlyOnce: true });
    }
    if (booking.customer_rating) {
      const customerId = booking.customer || booking.customer_id;
      if (booking.customer_token) {
        RequestPushMsg(
          booking.customer_token,
          {
            title: store.getState().languagedata.defaultLanguage.notification_title || "Notification",
            msg: (store.getState().languagedata.defaultLanguage.received_rating ? store.getState().languagedata.defaultLanguage.received_rating.toString().replace("X", booking.customer_rating.toString()) : `You received a ${booking.customer_rating} star rating`),
            screen: 'RideList',
            params: { tabIndex: 1 }
          }
        );
      }

      if (customerId) {
        onValue(userRatingsRef(customerId), snapshot => {
          let ratings = snapshot.val();
          let rating;
          if (ratings) {
            let sum = 0;
            const arr = Object.values(ratings);
            for (let i = 0; i < arr.length; i++) {
              sum = sum + arr[i].rate;
            }
            sum = sum + booking.customer_rating;
            rating = parseFloat(sum / (arr.length + 1)).toFixed(1);
          } else {
            rating = parseFloat(booking.customer_rating).toFixed(1);
          }
          update(singleUserRef(customerId), { rating: rating, customerRating: rating });
          push(userRatingsRef(customerId), {
            user: booking.driver || null,
            rate: booking.customer_rating
          });
        }, { onlyOnce: true });
      }
    }
  }
};

export const cancelBooking = (data) => (dispatch) => {
  const {
    singleBookingRef,
    singleUserRef,
    requestedDriversRef
  } = firebase;

  dispatch({
    type: CANCEL_BOOKING,
    payload: data,
  });

  update(singleBookingRef(data.booking.id), {
    status: 'CANCELLED',
    reason: data.reason,
    cancelledBy: data.cancelledBy
  }).then(() => {
    if (data.booking.shareToken && firebase.sharedTripsRef) {
      update(firebase.sharedTripsRef(data.booking.shareToken), {
        status: 'CANCELLED',
        active: false,
        updatedAt: Date.now()
      }).catch((err) => console.log('Error updating shared trip on cancel:', err));
    }
    if (data.booking.driver && (data.booking.status === 'NEW' || data.booking.status === 'ACCEPTED' || data.booking.status === 'ARRIVED')) {
      update(singleUserRef(data.booking.driver), { queue: false });
      if (data.booking.driver_token) {
        RequestPushMsg(
          data.booking.driver_token,
          {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.booking_cancelled + data.booking.id,
            screen: 'RideList',
            params: { tabIndex: 2 }
          }
        );
      }
      if (data.booking.customer_token) {
        RequestPushMsg(
          data.booking.customer_token,
          {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.booking_cancelled + data.booking.id,
            screen: 'RideList',
            params: { tabIndex: 2 }
          }
        );
      }
    }
    if (data.booking.status === 'NEW') {
      remove(requestedDriversRef(data.booking.id));
    }
  });
};

export const updateBookingImage = (booking, imageType, imageBlob) => async (dispatch) => {
  const {
    singleBookingRef,
    bookingImageRef
  } = firebase;
  await uploadBytesResumable(bookingImageRef(booking.id, imageType), imageBlob).then(() => {
    imageBlob.close()
    return getDownloadURL(bookingImageRef(booking.id, imageType))
  }).then((url) => {
    if (imageType == 'pickup_image') {
      booking.pickup_image = url;
    }
    if (imageType == 'deliver_image') {
      booking.deliver_image = url;
    }
    update(singleBookingRef(booking.id), booking);
    dispatch({
      type: UPDATE_BOOKING,
      payload: booking,
    });
  })
};

export const forceEndBooking = (booking) => async (dispatch) => {

  const {
    trackingRef,
    singleBookingRef,
    singleUserRef,
    walletHistoryRef,
    settingsRef,
  } = firebase;

  dispatch({
    type: UPDATE_BOOKING,
    payload: booking,
  });

  if (booking.status == 'STARTED') {

    push(trackingRef(booking.id), {
      at: new Date().getTime(),
      status: 'REACHED',
      lat: booking.drop.lat,
      lng: booking.drop.lng,
    });

    const end_time = new Date();
    const diff = (end_time.getTime() - parseFloat(booking.startTime)) / 1000;
    const totalTimeTaken = Math.abs(Math.round(diff));
    booking.trip_end_time = end_time.getHours() + ":" + end_time.getMinutes() + ":" + end_time.getSeconds();
    booking.endTime = end_time.getTime();
    booking.total_trip_time = totalTimeTaken;

    if (booking.customer_token) {
      RequestPushMsg(
        booking.customer_token,
        {
          title: store.getState().languagedata.defaultLanguage.notification_title,
          msg: store.getState().languagedata.defaultLanguage.driver_completed_ride,
          screen: 'BookedCab',
          params: { bookingId: booking.id }
        }
      );
    }

    update(singleUserRef(booking.driver), { queue: false });

    if (booking.prepaid) {

      const settingsdata = await get(settingsRef);
      const settings = settingsdata.val();

      onValue(singleUserRef(booking.driver), snapshot => {
        let walletBalance = parseFloat(snapshot.val().walletBalance);
        walletBalance = walletBalance + parseFloat(booking.driver_share);
        if (parseFloat(booking.cashPaymentAmount) > 0) {
          walletBalance = walletBalance - parseFloat(booking.cashPaymentAmount);
        }
        update(singleUserRef(booking.driver), { "walletBalance": parseFloat(walletBalance.toFixed(settings.decimal)) });

        let details = {
          type: 'Credit',
          amount: parseFloat(booking.driver_share).toFixed(settings.decimal),
          date: new Date().getTime(),
          txRef: booking.id
        }
        push(walletHistoryRef(booking.driver), details);

        if (parseFloat(booking.cashPaymentAmount) > 0) {
          let details = {
            type: 'Debit',
            amount: booking.cashPaymentAmount,
            date: new Date().getTime(),
            txRef: booking.id
          }
          push(walletHistoryRef(booking.driver), details);
        }
      }, { onlyOnce: true });

      if (booking.customer_token) {
        RequestPushMsg(
          booking.customer_token,
          {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.success_payment,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
          }
        );
      }

      if (booking.driver_token) {
        RequestPushMsg(
          booking.driver_token,
          {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.success_payment,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
          }
        );
      }
      booking.status = 'PAID';
    } else {
      booking.status = 'PENDING';
    }

    update(singleBookingRef(booking.id), booking);
  }
};

export const negotiateDriverOffer = (booking, driverUid, counterPrice) => (dispatch) => {
  const { singleBookingRef } = firebase;
  const numPrice = parseFloat(counterPrice);
  if (!numPrice || numPrice <= 0 || !booking || !driverUid) return;

  const currentOffer = (booking.driverOffers && booking.driverOffers[driverUid]) ? booking.driverOffers[driverUid] : {};
  const updatedOffer = {
    ...currentOffer,
    customerCounterPrice: numPrice.toFixed(2),
    negotiationStatus: 'CUSTOMER_COUNTERED',
    lastActionBy: 'customer',
    counterUpdatedAt: Date.now()
  };

  const updateObj = {};
  updateObj[`driverOffers/${driverUid}`] = updatedOffer;

  update(singleBookingRef(booking.id), updateObj);

  if (currentOffer.driver_token) {
    const symbol = store.getState().settingsdata?.settings?.symbol || '$';
    const lang = store.getState().languagedata.defaultLanguage || {};
    const customerName = booking.customer_name || 'Customer';
    RequestPushMsg(
      currentOffer.driver_token,
      {
        title: lang.notification_title || 'INDRIVING',
        msg: `${customerName} ${lang.customer_negotiated || 'proposed'}: ${symbol}${numPrice.toFixed(2)}`,
        screen: 'DriverTrips',
        params: { bookingId: booking.id }
      }
    );
  }
};

export const acceptCustomerNegotiation = (booking, driverUid) => (dispatch) => {
  const { singleBookingRef } = firebase;
  if (!booking || !driverUid || !booking.driverOffers || !booking.driverOffers[driverUid]) return;

  const offer = booking.driverOffers[driverUid];
  const agreedPrice = parseFloat(offer.customerCounterPrice || offer.trip_cost);
  if (!agreedPrice || agreedPrice <= 0) return;

  const commissionRate = parseFloat(booking.commission_rate || 0);
  const convenience_fees = booking.commission_type === 'flat' 
    ? commissionRate 
    : (agreedPrice * commissionRate / 100);
  const fleetAdminCommission = offer.fleetCommission ? parseFloat(booking.fleet_admin_comission || 0) : 0;
  const fleetCommissionFees = fleetAdminCommission > 0
    ? ((agreedPrice - convenience_fees) * fleetAdminCommission / 100).toFixed(2)
    : 0;
  const driverShare = (agreedPrice - parseFloat(fleetCommissionFees) - convenience_fees).toFixed(2);

  const updatedOffer = {
    ...offer,
    trip_cost: agreedPrice.toFixed(2),
    bidPrice: agreedPrice.toFixed(2),
    convenience_fees: convenience_fees.toFixed(2),
    driver_share: driverShare,
    fleetCommission: fleetCommissionFees || null,
    negotiationStatus: 'DRIVER_ACCEPTED',
    isAcceptedByDriver: true,
    lastActionBy: 'driver',
    counterUpdatedAt: Date.now()
  };

  const updateObj = {};
  updateObj[`driverOffers/${driverUid}`] = updatedOffer;

  update(singleBookingRef(booking.id), updateObj);

  if (booking.customer_token) {
    const symbol = store.getState().settingsdata?.settings?.symbol || '$';
    const lang = store.getState().languagedata.defaultLanguage || {};
    const driverName = offer.driver_name || 'Driver';
    RequestPushMsg(
      booking.customer_token,
      {
        title: lang.notification_title || 'INDRIVING',
        msg: `${driverName} ${lang.driver_accepted_offer || 'accepted your price'}: ${symbol}${agreedPrice.toFixed(2)}`,
        screen: 'BookedCab',
        params: { bookingId: booking.id }
      }
    );
  }
};

export const counterCustomerNegotiation = (booking, driverUid, counterPrice) => (dispatch) => {
  const { singleBookingRef } = firebase;
  const numPrice = parseFloat(counterPrice);
  if (!numPrice || numPrice <= 0 || !booking || !driverUid || !booking.driverOffers || !booking.driverOffers[driverUid]) return;

  const offer = booking.driverOffers[driverUid];
  const commissionRate = parseFloat(booking.commission_rate || 0);
  const convenience_fees = booking.commission_type === 'flat' 
    ? commissionRate 
    : (numPrice * commissionRate / 100);
  const fleetAdminCommission = offer.fleetCommission ? parseFloat(booking.fleet_admin_comission || 0) : 0;
  const fleetCommissionFees = fleetAdminCommission > 0
    ? ((numPrice - convenience_fees) * fleetAdminCommission / 100).toFixed(2)
    : 0;
  const driverShare = (numPrice - parseFloat(fleetCommissionFees) - convenience_fees).toFixed(2);

  const updatedOffer = {
    ...offer,
    trip_cost: numPrice.toFixed(2),
    bidPrice: numPrice.toFixed(2),
    driverCounterPrice: numPrice.toFixed(2),
    convenience_fees: convenience_fees.toFixed(2),
    driver_share: driverShare,
    fleetCommission: fleetCommissionFees || null,
    negotiationStatus: 'DRIVER_COUNTERED',
    lastActionBy: 'driver',
    counterUpdatedAt: Date.now()
  };

  const updateObj = {};
  updateObj[`driverOffers/${driverUid}`] = updatedOffer;

  update(singleBookingRef(booking.id), updateObj);

  if (booking.customer_token) {
    const symbol = store.getState().settingsdata?.settings?.symbol || '$';
    const lang = store.getState().languagedata.defaultLanguage || {};
    const driverName = offer.driver_name || 'Driver';
    RequestPushMsg(
      booking.customer_token,
      {
        title: lang.notification_title || 'INDRIVING',
        msg: `${driverName} ${lang.counter_offer || 'countered'}: ${symbol}${numPrice.toFixed(2)}`,
        screen: 'BookedCab',
        params: { bookingId: booking.id }
      }
    );
  }
};

export const shareTrip = (booking) => async (dispatch) => {
  const { singleBookingRef, sharedTripsRef, singleUserRef } = firebase;
  try {
    let token = booking.shareToken;
    if (!token) {
      const rand = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
      token = `trk_${rand}`;
      await update(singleBookingRef(booking.id), { shareToken: token });
      booking.shareToken = token;
    }

    let vehicleMake = booking.vehicle_make || (booking.selectedBid && booking.selectedBid.vehicle_make) || '';
    let vehicleModel = booking.vehicle_model || (booking.selectedBid && booking.selectedBid.vehicle_model) || '';
    let vehicleColor = booking.vehicle_color || booking.car_color || (booking.selectedBid && (booking.selectedBid.vehicle_color || booking.selectedBid.car_color)) || '';
    let vehicleNumber = booking.vehicle_number || (booking.selectedBid && booking.selectedBid.vehicle_number) || '';

    if ((!vehicleMake || !vehicleModel || !vehicleColor || !vehicleNumber) && booking.driver && singleUserRef) {
      try {
        const driverSnap = await get(singleUserRef(booking.driver));
        if (driverSnap.exists()) {
          const dData = driverSnap.val();
          if (!vehicleMake) vehicleMake = dData.vehicleMake || '';
          if (!vehicleModel) vehicleModel = dData.vehicleModel || '';
          if (!vehicleColor) vehicleColor = dData.car_color || dData.vehicle_color || dData.vehicleColor || '';
          if (!vehicleNumber) vehicleNumber = dData.vehicleNumber || '';
        }
      } catch (e) {
        console.log('Error fetching driver profile in shareTrip:', e);
      }
    }

    const driverLoc = booking.driver_location || null;
    const initialLat = (driverLoc && driverLoc.lat) || (booking.pickup && booking.pickup.lat) || 0;
    const initialLng = (driverLoc && driverLoc.lng) || (booking.pickup && booking.pickup.lng) || 0;

    const sharedTripData = {
      bookingId: booking.id,
      shareToken: token,
      passengerName: booking.customer_name || 'Passenger',
      status: booking.status || 'ACCEPTED',
      driverName: booking.driver_name || '',
      driverImage: booking.driver_image || '',
      driverRating: booking.driverRating ? String(booking.driverRating) : '5.0',
      carType: booking.carType || vehicleModel || '',
      carImage: booking.carImage || '',
      vehicleNumber: vehicleNumber,
      vehicleMake: vehicleMake,
      vehicleModel: vehicleModel,
      vehicleColor: vehicleColor,
      carColor: vehicleColor,
      pickup: booking.pickup || {},
      drop: booking.drop || {},
      waypoints: booking.waypoints || [],
      currentLocation: {
        lat: initialLat,
        lng: initialLng,
        heading: 0,
        at: Date.now()
      },
      active: !['COMPLETE', 'CANCELLED'].includes(booking.status),
      createdAt: Date.now(),
      expiresAt: Date.now() + 24 * 60 * 60 * 1000,
      updatedAt: Date.now()
    };

    if (sharedTripsRef) {
      await update(sharedTripsRef(token), sharedTripData);
    }
    return token;
  } catch (error) {
    console.error('Error in shareTrip action:', error);
    return null;
  }
};